import {
  RentGuaranteeType,
  RentType,
  useSearchZyusetuTemplateQuery,
  ZyusetuTemplateFragmentFragment,
  ZyusetuType,
} from "@/graphql/graphql";
import {useCallback, useEffect, useState} from "react";
import {AutocompleteInput} from "@/components/input/Autocomplete.tsx";
import {Box, Chip, Typography} from "@mui/material";

interface ZyusetuTemplateAutocompleteProps {
  onChange: (value: ZyusetuTemplateFragmentFragment | null) => void;
  rentGuaranteeType?: RentGuaranteeType;
  rentType?: RentType;
  zyusetuType: ZyusetuType;
}

//
//   type              ZyusetuType
//   rentType          RentType?
//   rentGuaranteeType RentGuaranteeType?

export function ZyusetuTemplateAutocomplete({
                                              onChange,
                                              rentGuaranteeType,
                                              rentType,
                                              zyusetuType
                                            }: ZyusetuTemplateAutocompleteProps) {
  const [value, setValue] = useState<ZyusetuTemplateFragmentFragment | null>(
    null,
  );
  
  const isRecommended = useCallback((template: ZyusetuTemplateFragmentFragment) => {
    return (template.rentType === rentType && template.rentGuaranteeType === rentGuaranteeType && template.type === zyusetuType)
  }, [rentGuaranteeType, rentType, zyusetuType])
  
  const [searchString, setSearchString] = useState("");
  
  const search = useSearchZyusetuTemplateQuery({
    searchString,
    zyusetuType
  });
  
  useEffect(() => {
    const recommended = search.data?.searchZyusetuTemplates.find(isRecommended);
    if (recommended) {
      setValue(recommended);
      onChange(recommended);
    }
  }, [isRecommended]); // eslint-disable-line react-hooks/exhaustive-deps
  
  return (
    <Box>
      <Typography color="text.secondary" variant="subtitle2" mb={0.5}>
        重説テンプレート
      </Typography>
      
      <AutocompleteInput
        onChange={(v) => {
          setValue(v);
          onChange(v);
        }}
        loading={search.isLoading}
        isOptionEqualToValue={(option, value) => option.id === value.id}
        value={value}
        multiple={false}
        getOptionLabel={(option) => `${option.title}`}
        fetchOptions={async (searchString: string) => {
          setSearchString(searchString);
        }}
        renderOption={(props, option) => {
          
          return (
            <li {...props}>
              {isRecommended(option) &&
                <Chip label={"提案"} color={'success'}/>}
              {option.title}
            </li>
          );
        }}
        options={search.data?.searchZyusetuTemplates.sort(
          (a) => {
            if (isRecommended(a)) {
              return -1;
            }
            return 1;
          }
        ) || []}
      />
    </Box>
  );
}
